import EVImg from '@components/EVImg/EVImg';
import { AspectBox } from '@components/Layout';
import Block from '@components/Layout/Block';
import Video from '@components/Video/';
import { FC } from 'react';
import { Caption, ContentContainer, Header, Location } from './styles';
import { getTestId } from '@util/getTestIds';

export interface InteriorHeroProps {
  header?: string;
  location?: string;
  caption?: string;
  videoSrc?: string;
  img?: string;
  imgFocalPoint?: any;
  source?: string;
  videoUpload?: string;
  backgroundColor?: boolean;
}

const InteriorHero: FC<InteriorHeroProps> = ({
  header,
  location,
  caption,
  videoSrc,
  img,
  imgFocalPoint,
  source,
  videoUpload,
  backgroundColor = false,
}) => {
  return (
    //figure this our about if I should use image as a general image and video place holder, sharing that usage
    <Block fullOnMobile background={backgroundColor ? 'secondaryBg' : 'bg'}>
      {(header || caption) && (
        <ContentContainer $backgroundColor={backgroundColor}>
          {header && (
            <Header data-testid={`${getTestId(header)}-header`} $videoSrc={videoSrc} $img={img}>
              {header}
            </Header>
          )}
          {caption && (
            <div>
              <Caption>{caption}</Caption>
            </div>
          )}
          {location && (
            <div>
              <Location>{location}</Location>
            </div>
          )}
        </ContentContainer>
      )}
      {(imgFocalPoint || img || videoSrc || videoUpload) &&
        (source && source === 'Image Upload' && (imgFocalPoint || img) ? (
          <AspectBox $ratio={[1, 2 / 1, 2 / 1]}>
            {imgFocalPoint ? (
              <EVImg
                dataTestId={`interior-hero-${header}`}
                imageFocalPointData={imgFocalPoint}
                priority
              />
            ) : (
              <EVImg dataTestId={`interior-hero-${header}`} src={img} priority sizes={'100vw'} />
            )}
          </AspectBox>
        ) : source && source === 'Video Upload' ? (
          <AspectBox $ratio={16 / 9}>
            <Video
              video_source={false}
              videoUpload={videoUpload}
              posterImage={imgFocalPoint ? imgFocalPoint.fields?.img?.file?.url : null}
              muted={true}
              loop={true}
              controls={true}
            />
          </AspectBox>
        ) : source && source === 'Video Url' ? (
          <AspectBox $ratio={16 / 9}>
            <Video
              video_source={true}
              youTubeUrl={videoSrc}
              posterImage={imgFocalPoint ? imgFocalPoint.fields?.img?.file?.url : null}
              muted={true}
              loop={true}
              controls={true}
            />
          </AspectBox>
        ) : null)}
    </Block>
  );
};
export default InteriorHero;
